import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom' 

function ViewMedia() {
const navigate = useNavigate()
const { state } = useLocation()

const files = state?.files || []
const type = state?.type || 'image'

if (!files.length) {
    return (
        <div className="viewMediaPage">
            <div className="viewMediaContainer">
                <div className="viewMediaTop">
                    <button
                        className="viewMediaBack"
                        onClick={() => navigate(-1)}
                    >
                        Back
                    </button>
                </div>
            </div>
        </div>
    )
}

return (
    <div className="viewMediaPage">
        <div className="viewMediaContainer">

            <div className="viewMediaTop">
                <h5>Media Preview</h5>
                <button
                    className="viewMediaBack"
                    onClick={() => navigate(-1)}
                >
                    Back
                </button>
            </div>

            <div className="viewMediaCard">
                {type === 'video' ? (
                    <video
                        src={files[0]}
                        controls
                    />
                ) : (
                    <img
                        src={files[0]}
                        alt="media"
                    />
                )}
            </div>

        </div>
    </div>
)


}

export default ViewMedia